import { render, staticRenderFns } from "./InfoSelect.vue?vue&type=template&id=10ce3532&scoped=true&"
import script from "./InfoSelect.vue?vue&type=script&lang=js&"
export * from "./InfoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce3532",
  null
  
)

export default component.exports